<template lang="html">

<div class="subComponent">

  <el-dialog
    title="请选择要创建的解读类型"
    :visible.sync="openstate"
    width="450px"
    @open="openHandle"
    @closed="handleClose">

    <div class="cbody">
      <el-radio-group v-model="radio">
        <el-radio :label="1">文字</el-radio>
        <el-radio :label="2">图片</el-radio>
        <el-radio :label="3">视频</el-radio>
      </el-radio-group>
    </div>

    <div slot="footer" class="dialog-footer">
        <el-button @click="openstate = false" size="small">取 消</el-button>
        <el-button @click="goUns" size="small" type="primary">确 定</el-button>
    </div>
 </el-dialog>

</div>

</template>

<script>
export default {

    data(){
        return{
            openstate:false,
            radio:1
        }
    },

    methods:{
        goUns:function(){
            this.openstate = false;
            this.$emit('goCreate',this.radio);
        }
    }
}
</script>

<style lang="css">

.el-dialog__body{
    padding: 12px 20px !important;
}

.el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// unsModel.vue?e55751e0